
import BusObject from '../../utils/eventBus'
import Storage from 'store'
import qs from 'qs'
import domain from '../../server-config/domain.config'
import { refreshToken } from '_h/account'
import Vue from 'vue'

export default ({ app, store, $axios }) => {
  // 设置自定义请求头
  $axios.setHeader('Content-Type', 'application/json')

  // 请求队列
  const queue = {}

  // 用于存储正在进行的请求
  const pendingRequests = new Map()
  // 生成请求的唯一标识
  const generateRequestKey = (config) => {
    const { method, url, params, data } = config
    return [method, url, JSON.stringify(params), JSON.stringify(data)].join('&')
  }

  $axios.onRequest(config => {
    // 打开loading动画
    if (Object.keys(queue).length === 0) {
      store.commit('showLoading')
    }

    // 添加请求队列
    queue[config.url] = true
  })

  // 请求拦截器
  $axios.interceptors.request.use(config => {
    // token有效期低于10分钟时， 刷新token
    // const timeGap = app.$cookies.get('user-token-timeout') * 1000 - new Date().getTime()
    // if (app.$cookies.get('user-refresh-token') && app.$cookies.get('user-token-timeout') && (timeGap <= 600000 && timeGap > 0)) {
    //   app.$SetCookieFn('user-token-timeout', null)
    //   $axios.request(refreshToken({
    //     refreshToken: app.$cookies.get('user-refresh-token')
    //   }))
    //     .then((res) => {
    //       app.$SetCookieFn('user-token', res.data.data.accessToken)
    //       app.$SetCookieFn('user-refresh-token', res.data.data.refreshToken)
    //       app.$SetCookieFn('user-token-timeout', res.data.data.accessTokenTimeout)
    //     })
    // }
    config.withCredentials = config.withCredentials !== 0
    // TODO 服务端目前没有做国际化参数处理 目前售后详情页中做了处理 加了请求头,需要可以统一使用
    // store.locale
    if (app.$cookies.get('user-token')) {
      const bearerUrl = [
        domain.AFTER_API_URL,
        domain.K_API_URL,
        domain.K_AFTER_URL
      ]
      let bearerBoo = false
      bearerBoo = bearerUrl.some(item => config.url.includes(item))

      if (bearerBoo) {
        config.headers.common.Authorization = `Bearer ${app.$cookies.get('user-token')}`
      } else {
        config.headers.common.AccessToken = app.$cookies.get('user-token')
      }

      if (config.headers['Client-Id'] === 'LOGISTICS-CUSTOMER-PC') {
        // 物流接口添加指定头部token, 先写死测试
        config.headers.common['X-JWT'] = `${app.$cookies.get('user-token')}`
      }
    }
    if (app.$cookies.get('user-name')) {
      config.headers.common.userName = app.$cookies.get('user-name')
    }
    if (app.$cookies.get('kili-language')) {
      config.headers.common['kili-language'] = app.$cookies.get('kili-language')
    }

    // 只针对get方式进行序列化
    if (config.method === 'get') {
      config.paramsSerializer = function(params) {
        return qs.stringify(params, { arrayFormat: 'repeat' })
      }
    }

    // 针对使用proxy后ssr路径错误
    // if (!global.document) {
    //   let baseURL = ''
    //   if (!/^http(s?):\/\//.test(config.url)) {
    //     baseURL = domain.EBES_B2C_SELLER_API
    //   }

    //   config.baseURL = baseURL
    // }
    let baseURL = ''
    if (!/^http(s?):\/\//.test(config.url)) {
      baseURL = domain.EBES_B2C_SELLER_API
    }
    config.baseURL = baseURL

    // 针对seller api接入增加Request-Nonce请求头， 以便于后端根据参数排查日志定位问题（入驻重复数据）
    if (config.baseURL.indexOf('seller-api.') > -1) {
      config.headers.common['Request-Nonce'] = new Date().getTime()
    }

    // 针对非 Get 请求类型进行拦截， 防止重复请求
    if (config.method !== 'get') {
      const requestKey = generateRequestKey(config)
      if (pendingRequests.has(requestKey)) {
        // 取消重复请求
        const cancelTokenSource = pendingRequests.get(requestKey)
        cancelTokenSource.cancel('Duplicate request canceled.')
      }
      const cancelTokenSource = $axios.CancelToken.source()
      config.cancelToken = cancelTokenSource.token
      pendingRequests.set(requestKey, cancelTokenSource)
    }

    return config
  })

  // 响应拦截
  $axios.interceptors.response.use(
    response => {
      if (response.headers['permission-changed'] === 'True') {
        const { $Bus, BusEvent } = BusObject
        $Bus.$emit(BusEvent.FLAG_NAVLEFT)
      }
      const requestKey = generateRequestKey(response.config)
      pendingRequests.delete(requestKey)
      return response
    },
    error => {
      console.error(error)
      if (error.response) {
        // token过期
        if (error.response.data.code === 1001) {
          // token 失效时清理所有 cookie 和登陆状态， 防止产生重复跳转的问题
          store.commit('logOut')
          app.$cookies.removeAll({ path: '/' })
          app.$cookies.removeAll({ path: '/seller-center' })
          app.router.push({
            path: '/login',
            query: {
              code: 1001
              // redirect: `${pathname}${search}`
            }
          })
        }
        if (error.response.status === 500) {
          Vue.prototype.$message.error('Request failed, please try again later.')
          return false
        }
        if (error.response.status === 400) {
          Vue.prototype.$message.error(error.response.data.msg)
          return false
        }
        if (error.response.status === 404) {
          error.response.data.msg
            ? Vue.prototype.$message.error(error.response.data.msg)
            : Vue.prototype.$message.error('Request failed with status code 404')
          return false
        }
        if (error.response.headers['permission-changed'] === 'True') {
          app.router.push({
            path: '/seller-center/home'
          })
          Storage.set('acountStatus', true)
          const { $Bus, BusEvent } = BusObject
          $Bus.$emit(BusEvent.FLAG_NAVLEFT)
        }
      }
      if ($axios.isCancel(error)) {
        console.log('Request canceled', error.message)
      } else {
        const requestKey = generateRequestKey(error.config)
        pendingRequests.delete(requestKey)
      }
      return Promise.reject(error)
    }
  )

  $axios.onResponse(responseObj => {
    // 删除请求队列
    if (new RegExp(responseObj.config.baseURL).test(responseObj.config.url)) {
      const url = responseObj.config.url.replace(
        responseObj.config.baseURL,
        ''
      )
      delete queue[url]
    } else delete queue[responseObj.config.url]

    // 关闭loading动画
    if (Object.keys(queue).length === 0) {
      store.commit('closeLoading')
    }
  })

  // $axios.onResponseError(error => {
  //   console.log('onResponseError：',error.response);
  // })

  $axios.onError(error => {
    store.commit('closeLoading')
    switch (error.response.data.code) {
      case 1001: // token失效
        break

      default:
        break
    }
  })
}
